import { Component, Input } from '@angular/core';

@Component({
  selector: 'vi-ui-text',
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
  standalone: false
})
export class TextComponent {
  @Input() text: string;
  @Input() size: '12-16' | '13-18' | '14-20' = '14-20';
  @Input() inline?: boolean = false;
  @Input() color?: string = 'var(--type-primary)';
  @Input() fontWeight?: number | string;
  @Input() isSecondary: boolean = false;
  @Input() iconClass?: string;
  @Input() iconColor?: string = 'var(--type-primary)';

  public get textColor(): string {
    return this.isSecondary ? 'var(--type-secondary)' : this.color;
  }
}
